export default __webpack_public_path__ + "static/media/1.a67ef646.mp3";